<template>
    <div class="InvalidIP">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="paper" style="margin-top:40px;">
                    <h1 class="center-text red">INVALID LOCATION</h1>
                    <h3 class="center-text red">The account type you have has location restrictions, and you have attempted to access O.L.I.V.E.R. from a disallowed location.</h3>
                    <h4 class="center-text red">For more information on this, please contact your supervisor, or if you are a non Olive Crest employee, please contact your Olive Crest representative.</h4>
                </div>
                
            </div>
        </div>
        
    </div>
</template>

<script>

    export default {
        name: "InvalidIP"
        
    }
</script>
